define(() => {

   return ['JsonRPCService', function (JsonRPCService) {
       return {
           find: find,
           validateCompanyUID: validateCompanyUID,
       };

       function find(callGroups, postalCode, companyName, isoCode) {
           return JsonRPCService.send('companysearch', 'companysearch', 'find', [postalCode, companyName, isoCode], callGroups, true);
       }

       function validateCompanyUID(UID) {

           if (!UID) {
               return false;
           }

           const lowerCaseUid = UID.toLowerCase();

           // First checkss
           if (lowerCaseUid.length != 12
               || (!lowerCaseUid.startsWith('che') && !lowerCaseUid.startsWith('adm'))) {
               return false;
           }

           const asInt = parseInt(lowerCaseUid.substring(3, 11));
           const checksum = parseInt(lowerCaseUid.substring(11, 12));
           const check = mod11(asInt);
           return (checksum == check);
       }

       // Private functions
       function mod11(no) {

           // siehe
           // http://de.wikipedia.org/wiki/Pr%C3%BCfziffer#Modulo_11
           // http://merlin2010.blogspot.ch/2013/02/prufzifferberechnung-schweizer.html

           const weight = [4, 5, 6, 7, 2, 3, 4, 5];
           let sum = 0;
           for (let i = 0; i < 8; i++) {
               const digit = (no / Math.pow(10, i) % 10) | 0;
               sum += (digit * weight[i]);
           }
           const ret = 11 - (sum % 11);
           switch (ret) {
               case 10:
                   return -1;
               case 11:
                   return 0;
               default:
                   return ret;
           }
       }
   }];
});



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/basler/services/BaslerCompanySearchService.js